import React, { Component } from "react";
import { connect } from "react-redux";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";

class RelatedTicketTableModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      ticketHeaders: {
        ticketNumber: "Ticket Number",
        loadDate: "Load Date",
        loadNumber: "Load Number",
        quantity: "Est. Load Bushels",
        delivered: "Reconciled Load Bushels",
        balance: "Balance",
        stage: "Status"
      },
      order: "desc",
      orderBy: "id"
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.ticketList &&
      this.props.ticketList !== nextProps.ticketList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
  }

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  render() {
    const { order, orderBy, fetchingComplete, ticketHeaders } = this.state;
    const { ticketList, ErrorMessage } = this.props;
    return (
      <div className="">
        {fetchingComplete ? (
          ErrorMessage && ErrorMessage.message ? (
            <div className="ErrorMessage">{ErrorMessage.message}</div>
          ) : (
            <CreateTable
              order={order}
              orderBy={orderBy}
              headerRows={ticketHeaders}
              rowData={ticketList}
              onRequestSort={this.handleRequestSort}
              isMenuRequired={false}
            />
          )
        ) : (
          <Loader />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ticketList: state.riskReducer.ticketList,
    ErrorMessage: state.globalserverMessage.ErrorMessage
  };
}

export default connect(mapStateToProps)(RelatedTicketTableModel);



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/RelatedTicketTableModal.js